import BaseApi from "./base";

class FadProcesosApi extends BaseApi {
  constructor() {
    super("fadProcesos");
  }
}

export default new FadProcesosApi();
